<template>
  <b-button
    pill
    @click="apply(item)"
    variant="primary"
    :size="size"
    :block="block"
    :disabled="isEnrolled(item.id)"
  >
    {{
      isEnrolled(item.id)
        ? $t("vacancy.actions.already-applied")
        : $t("vacancy.actions.apply")
    }}
  </b-button>
</template>

<script>
import _ from "lodash-es";
import { useApplications } from "@state/user/applications";
import companyMixin from "@state/company";
import { trackOnce, APPLICATION_START } from "@/plugins/tracking";

export default {
  name: "VacancyApplyButton",
  mixins: [companyMixin],
  props: {
    item: {
      type: Object,
      required: true
    },
    size: {
      type: String,
      default: "md"
    },
    block: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const applications = useApplications();

    return {
      applications
    };
  },
  mounted() {
    if (this.$auth.check()) {
      this.applications.load();
    }
  },
  methods: {
    isEnrolled(id) {
      if (!this.$auth.check()) {
        return false;
      }
      if (this.applications.list) {
        return _.size(_.find(this.applications.list, { id: id })) > 0;
      }
      return false;
    },
    apply(item) {
      // Tracking de marketing (não bloqueante): uma vez por vaga por sessão
      trackOnce(`as:${item.id}`, APPLICATION_START, {
        job_id: item.id,
        job_title: item.occupation || item.seo_title,
      });

      if (this.company.config.is_agreggator) {
        this.$bvModal
          .msgBoxConfirm(
            "Você será redirecionado para o portal " + item.publisher_company,
            {
              title: "Redirecionando",
              size: "sm",
              buttonSize: "sm",
              okVariant: "primary",
              okTitle: "Ok",
              cancelTitle: "Cancelar",
              footerClass: "p-2 rounded-pill",
              hideHeaderClose: false,
              centered: true,
            }
          )
          .then((value) => {
            if (value) {
              window.open(item.enroll_url, "_blank");
            }
          })
          .catch((err) => {
            // An error occurred
          });
      } else if (this.$auth.check() && _.isEmpty(this.$auth.user().cpf)) {
        this.$router.push({
          name: "complete-registration",
        });
      } else {
        if (this.$auth.check()) {
          this.$router.push({
            name: "vacancy-enroll",
            params: { vacancy_id: item.id },
          });
        } else {
          this.$router.push({
            name: "register1",
            params: { vacancy_id: item.id },
          });
        }
      }
    }
  }
};
</script>